/**
 * Determines the current filter index and the next filter index based upon the list of filter
 * options and the currently selected option. The return value is intended to be used with the
 * TextDial control, i.e. if the next index would go past the end of the list, it is set to 0
 * instead.
 * @param filterOptions a list of DropdownOptions
 * @param currentOption the currently selected DropdownOption
 */
export function getTextDialFilterIndexes<V>(
    filterOptions: DropdownOption<V>[],
    currentOption: DropdownOption<V>,
): { filterIndex: number; nextFilterIndex: number } {
    const filterIndex = filterOptions.reduce(
        (acc: number, { value }, index: number): number => {
            if (currentOption.value === value) {
                return index;
            }

            return acc;
        },
        -1,
    );

    const nextFilterIndex =
        filterIndex < filterOptions.length - 1 ? filterIndex + 1 : 0;

    return {
        filterIndex,
        nextFilterIndex,
    };
}
